
export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any } | undefined;
  
    constructor(data?: IProblemDetails) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  
    init(_data?: any) {
      if (_data) {
        this.type = _data["type"];
        this.title = _data["title"];
        this.status = _data["status"];
        this.detail = _data["detail"] !==undefined ? _data["detail"] : _data["message"];
        this.instance = _data["instance"];
        if (_data["extensions"]) {
          this.extensions = {} as any;
          for (let key in _data["extensions"]) {
            if (_data["extensions"].hasOwnProperty(key))
              (<any>this.extensions)![key] = _data["extensions"][key];
          }
        }
      }
    }
  
    static fromJS(data: any): ProblemDetails {
      data = typeof data === "object" ? data : {};
      let result = new ProblemDetails();
      result.init(data);
      return result;
    }
  
    toJSON(data?: any) {
      data = typeof data === "object" ? data : {};
      data["type"] = this.type;
      data["title"] = this.title;
      data["status"] = this.status;
      data["detail"] = this.detail;
      data["instance"] = this.instance;
      if (this.extensions) {
        data["extensions"] = {};
        for (let key in this.extensions) {
          if (this.extensions.hasOwnProperty(key))
            (<any>data["extensions"])[key] = this.extensions[key];
        }
      }
      return data;
    }
  }
  
  export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any } | undefined;
  }
  
 
  